import { Modal, Button } from 'react-bootstrap';
import { AlertCircle } from 'lucide-react';

function ConfirmDeleteModal({ show, onClose, onConfirm, itemName = 'this item', loading = false }) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Body className="text-center p-4">

        <AlertCircle size={64} color="#FF5C5C" strokeWidth={1.5} className="mb-3" />

        <h4 className="fw-bold mb-3">Are you sure?</h4>
        <p className="text-muted mb-4">
          Do you want to delete <strong>{itemName}</strong>?
        </p>

        <div className="d-flex justify-content-center gap-3">
          <Button
            variant="danger"
            style={{ backgroundColor: '#FF5C5C', border: 'none', minWidth: '120px' }}
            onClick={onConfirm}
            disabled={loading}
          >
           {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              </>
            ) : (
              "Delete"
            )}
          </Button>

          <Button
            variant="secondary"
            style={{ backgroundColor: '#E0E0E0', color: '#333', border: 'none', minWidth: '120px' }}
            onClick={onClose}
            disabled={loading} 
          >
            Cancel
          </Button>
        </div>

      </Modal.Body>
    </Modal>
  );
}

export default ConfirmDeleteModal;
